var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeRIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0,
    fill: "#D8D8D8",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5535,5.48972L12.6664,7.37678C12.071,7.97211,11.10572,7.97211,10.51028,7.37678L8.62322,5.48972C8.02789,4.89428,8.02789,3.929,8.62322,3.33356L10.51028,1.446494C11.10572,0.8511690000000001,12.071,0.8511690000000001,12.6664,1.446494L14.5535,3.33356C15.1488,3.929,15.1488,4.89428,14.5535,5.48972ZM6.19459,7.26914L3.52378,7.26914C2.682841,7.26914,2,6.5863,2,5.74536L2,3.07791C2,2.23361,2.682841,1.55077,3.52378,1.55077L6.19123,1.55077C7.03553,1.55077,7.71837,2.23361,7.71837,3.07455L7.71837,5.742C7.71837,6.5863,7.03553,7.26914,6.19459,7.26914ZM12.9221,13.9966L10.25464,13.9966C9.4137,13.9966,8.73086,13.3138,8.73086,12.4729L8.73086,9.80541C8.73086,8.96447,9.4137,8.28163,10.25464,8.28163L12.9221,8.28163C13.763,8.28163,14.4459,8.96447,14.4459,9.80541L14.4459,12.4729C14.4459,13.3138,13.763,13.9966,12.9221,13.9966ZM6.19459,13.9966L3.52378,13.9966C2.682841,13.9966,2,13.3138,2,12.4729L2,9.80541C2,8.96111,2.682841,8.27827,3.52378,8.27827L6.19123,8.27827C7.03217,8.27827,7.71501,8.96111,7.71501,9.80204L7.71501,12.4695C7.71874,13.3118,7.03694,13.9966,6.19459,13.9966Z",
    fill: "#41A9FE",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRIcon2);
export default __webpack_public_path__ + "static/media/home_r_icon2.2518f3bc8fe116fa59dc62e274babafa.svg";
export { ForwardRef as ReactComponent };